import React, { Component } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import SurveyForm from "./Components/Requests/com.survey.form"


//import * as $ from "jquery";

//window.jQuery = window.$ = $;

class App extends Component { 
  render() {
    return (
      <div>
      <Router>
        <Switch>
          <Route exact path="/" component={SurveyForm}></Route>       
        </Switch>
      </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx